export const RISK = {
  low: { color: "#30D158", label: "LOW", glow: "rgba(48,209,88,0.4)" },
  medium: { color: "#FFD60A", label: "MED", glow: "rgba(255,214,10,0.45)" },
  high: { color: "#FF9F0A", label: "HIGH", glow: "rgba(255,159,10,0.5)" },
  critical: { color: "#FF3B30", label: "CRIT", glow: "rgba(255,59,48,0.6)" },
};

export const ASSET_META = {
  road: { label: "Roads", icon: "route" },
  port: { label: "Ports & Harbours", icon: "anchor" },
  bridge: { label: "Bridges", icon: "milestone" },
  shelter: { label: "Shelters & Medical", icon: "hospital" },
};

export const SCENARIOS = {
  flooding: { label: "Coastal + rain flood", icon: "waves", desc: "Still-water level over the 37 m SRTM terrain (connected to the sea) + gully runoff" },
};

export const THREAT = {
  CLEAR:    { color: "#10B981", label: "ALL CLEAR",        glow: "rgba(16,185,129,0.25)" },
  WATCH:    { color: "#FBBF24", label: "WATCH",            glow: "rgba(251,191,36,0.30)" },
  WARNING:  { color: "#F97316", label: "WARNING",          glow: "rgba(249,115,22,0.35)" },
  SEVERE:   { color: "#EF4444", label: "SEVERE",           glow: "rgba(239,68,68,0.40)" },
  CRITICAL: { color: "#FF0055", label: "CRITICAL",         glow: "rgba(255,0,85,0.50)" },
};

export const GULLY = {
  normal:    { color: "#38bdf8", label: "NORMAL" },
  elevated:  { color: "#FFD60A", label: "ELEVATED" },
  surcharge: { color: "#FF9F0A", label: "SURCHARGE" },
  overflow:  { color: "#FF3B30", label: "OVERFLOW" },
};

export function threatFor(waterLevel, isolated, datum = 1.0, overflow = 0) {
  if (waterLevel <= datum && !overflow && !isolated) return "CLEAR";
  if (isolated > 15 || waterLevel > 4.5) return "CRITICAL";
  if (isolated > 5 || waterLevel > 3.0 || overflow >= 15) return "SEVERE";
  if (waterLevel > 1.8 || overflow >= 5) return "WARNING";
  return "WATCH";
}
